import { $, $$ } from '../helpers/selectors';
import Card from './Card';
import createFocusTrap from 'NM/focus-trap/dist/focus-trap';
const savedContentControls = $('.dashboard-control');

const SavedContents = () => {
  if (! savedContentControls) {
    return false;
  }

  const $j = jQuery; // eslint-disable-line
  const body = document.body;
  let isScrollDisabled = false;
  let lastRecordedScroll = 0;

  // Disable the scrolling
  const disableScroll = () => {
    if (! isScrollDisabled && typeof document !== 'undefined' && document.body) {
      const bounds = document.body.getBoundingClientRect();
      isScrollDisabled = true;
      // save the current scroll position
      lastRecordedScroll = -(bounds.top) || 0;

      // set the styling of body to a fixed position
      // and its top position to the `this.lastRecordedScroll` value
      document.body.style.position = 'fixed';
      document.body.style.top = `-${ lastRecordedScroll }px`;
      document.body.style.width = '100vw';
      document.body.style.overflow = 'hidden';
    }
  };
  // Enable the scrolling
  // Reset the styling set by the `disableScroll()` function
  const enableScroll = () => {
    if (typeof document !== 'undefined' && document.body && typeof window !== 'undefined') {
      if (isScrollDisabled) {
        isScrollDisabled = false;
        const lastBodyScroll = lastRecordedScroll;
        // reset the styling of the body
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        // scroll to the saved position
        window.scrollTo(0, lastBodyScroll);
      }
    }
  };

  function SavedContentsFunc() {
    const removeBtns = $$('.js-remove-saved-content--yes');
    const removeModalsOpen = $$('.js-remove-saved-content');
    const removeModalsClose = $$('.js-remove-saved-content--close, .js-remove-saved-content--cancel');
    const copyToClipboard = $$('.js-copy-link');
    const elementsToBeHidden = $$('#cookie-notice, .menu, .footer, .hero, .sidebar-menu, .hub-pager, .hub-result__list-item, .reachout, .card, .dashboard-control');
    const wpApi = window.wpApiSettings;
    const nonce = wpApi.nonce;
    const url = wpApi.root;
    let modalElem = null;
    let modalFocuselem = null;
    let modalElemParent = null;

    if (copyToClipboard) {
      copyToClipboard.forEach(copyBtn => {
        copyBtn.addEventListener('click', e => {
          const targetElem = $('.card a', e.currentTarget.closest('.hub-result__list-item'));
          const cardTitle = e.currentTarget.getAttribute('data-card-title');
          const dummy = document.createElement('input'),
            text = targetElem.href;

          document.body.appendChild(dummy);
          dummy.value = text;
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);

          document.execCommand('copy');

          copyBtn.parentNode.classList.add('is-copied');

          window.dataLayer.push({
            event: 'profile',
            eventType: 'copy content link click',
            cardTitle,
          });

          setTimeout(() => {
            copyBtn.parentNode.classList.remove('is-copied');
          }, 2000);
        });
      });
    }

    removeModalsOpen.forEach(removeBtn => {
      const postID = removeBtn.getAttribute('data-id');

      removeBtn.addEventListener('click', () => {
        modalElem = $('.remove-modal[data-id="' + postID + '"]');
        modalElemParent = modalElem.closest('.hub-result__list-item');
        if (modalElem) {
          body.classList.add('overflow-hidden');
          disableScroll();
          modalElem.removeAttribute('aria-hidden');
          modalElem.classList.add('is-visible');
          elementsToBeHidden.forEach(elem => {
            if (elem !== modalElemParent) {
              elem.setAttribute('aria-hidden', 'true');
            }
          });
          modalFocuselem = createFocusTrap('.remove-modal[data-id="' + postID + '"]', {
            allowOutsideClick: () => true,
            initialFocus: '.remove-modal[data-id="' + postID + '"] .js-remove-saved-content--yes',
          });
          modalFocuselem.activate();
          setTimeout(() => {
            $('.remove-modal[data-id="' + postID + '"] .js-remove-saved-content--yes').focus();
          }, 100);
        }
      });
    });

    removeModalsClose.forEach(modalClose => {
      modalClose.addEventListener('click', () => {
        if (modalElem) {
          body.classList.remove('overflow-hidden');
          modalFocuselem.deactivate();
          modalElem.setAttribute('aria-hidden', 'true');
          modalElem.classList.remove('is-visible');
          modalElem = null;
          enableScroll();

          elementsToBeHidden.forEach(elem => {
            elem.removeAttribute('aria-hidden');
          });
        }
      });
    });

    removeBtns.forEach(removeBtn => {
      const postID = removeBtn.getAttribute('data-id');
      const cardTitle = removeBtn.getAttribute('data-card-title');
      const removeCtrlBtn = $('.js-remove-saved-content[data-id="' + postID + '"]');

      if (! removeBtn.classList.contains('walkthrough-delete')) {
        removeBtn.addEventListener('click', () => {
          fetch(`${ url }bookmark/remove/${ postID }?_wpnonce=${ nonce }`)
            .then(response => {
              if (! response.ok) {
                throw Error(response.statusText);
              }
              return response.json();
            }).then(response => {
              if (response.data.code === 200) {
                $('.remove-modal[data-id="' + postID + '"]').classList.remove('is-visible');
                removeCtrlBtn.parentNode.classList.toggle('is-removed');

                window.dataLayer.push({
                  event: 'profile',
                  eventType: 'remove content click',
                  cardTitle,
                });

                if (modalElem) {
                  body.classList.remove('overflow-hidden');
                  modalFocuselem.deactivate();
                  modalElem.setAttribute('aria-hidden', 'true');
                  modalElem.classList.remove('is-visible');
                  modalElem = null;
                  enableScroll();

                  elementsToBeHidden.forEach(elem => {
                    elem.removeAttribute('aria-hidden');
                  });
                }

                setTimeout(() => {
                  if (removeBtns.length > 1) {
                    FWP.refresh(); // eslint-disable-line
                  } else {
                    location.reload(); // eslint-disable-line
                  }
                }, 2000);
              }
            }).catch(error => {
              // eslint-disable-next-line
              console.log(error);
            });
        });
      } else {
        removeBtn.addEventListener('click', () => {
          fetch(`${ url }wp/v2/walkthrough/${ postID }`, {
            method: 'DELETE',
            body: null,
            headers: {
              'Content-Type': 'application/json',
              'X-WP-Nonce': nonce,
            },
          })
            .then(response => {
              if (! response.ok) {
                throw Error(response.statusText);
              }
              return response.json();
            }).then(response => {
              if (response.status === 'trash') {
                $('.remove-modal[data-id="' + postID + '"]').classList.remove('is-visible');
                removeCtrlBtn.parentNode.classList.toggle('is-removed');

                window.dataLayer.push({
                  event: 'profile',
                  eventType: 'remove walkthrough click',
                  cardTitle,
                });

                if (modalElem) {
                  body.classList.remove('overflow-hidden');
                  modalFocuselem.deactivate();
                  modalElem.setAttribute('aria-hidden', 'true');
                  modalElem.classList.remove('is-visible');
                  modalElem = null;
                  enableScroll();

                  elementsToBeHidden.forEach(elem => {
                    elem.removeAttribute('aria-hidden');
                  });
                }

                setTimeout(() => {
                  if (removeBtns.length > 1) {
                    FWP.refresh(); // eslint-disable-line
                  } else {
                    location.reload(); // eslint-disable-line
                  }
                }, 2000);
              }
            }).catch(error => {
              // eslint-disable-next-line
              console.log(error);
            });
        });
      }
    });
  }

  function savedContentsA11y() {
    const firstCard = document.querySelector('.saved-contents .hub-result__list-item:first-child .card__link-cover');
    const paginationNext = $j('.facetwp-page.next');
    const paginationPrev = $j('.facetwp-page.prev');
    const paginations = $j('.facetwp-page:not(.next):not(.prev)');

    $j('.facetwp-page').on('click', e => {
      const pageElem = $j(e.target).hasClass('prev') || $j(e.target).hasClass('next') ? $j(e.target).hasClass('prev') ? 'prev' : 'next' : $j(e.target).attr('data-page'); // eslint-disable-line

      window.dataLayer.push({
        event: 'pagination',
        clickTarget: pageElem,
      });
    });

    if (firstCard) {
      firstCard.focus();
    }

    setTimeout(() => {
      if (paginationNext.attr('data-page')) {
        paginationNext.attr('aria-label', 'Go to Page ' + paginationNext.attr('data-page'));
        paginationNext.removeAttr('aria-hidden');
        paginationNext.attr('tabindex', '0');
      } else {
        paginationNext.attr('aria-hidden', 'true');
        paginationNext.attr('tabindex', '-1');
      }

      if (paginationPrev.attr('data-page')) {
        paginationPrev.attr('aria-label', 'Go to Page ' + paginationPrev.attr('data-page'));
        paginationPrev.removeAttr('aria-hidden');
        paginationPrev.attr('tabindex', '0');
      } else {
        paginationPrev.attr('aria-hidden', 'true');
        paginationPrev.attr('tabindex', '-1');
      }

      paginations.each(function() {
        $j(this).attr('aria-label', 'Page ' + $j(this).attr('data-page'));
      });
    }, 50);
  }

  //Initialize the save content controls
  SavedContentsFunc();
  savedContentsA11y();

  // Re init the save content controls on paginate
  jQuery(document).on('facetwp-loaded', function () { // eslint-disable-line
    SavedContentsFunc();
    Card();
    savedContentsA11y();

    const elem = document.getElementById('#saved-results');

    if (elem) {
      /* eslint-disable */
      $j('html, body').animate({
        scrollTop: elem.offset().top - 160,
      }, 800);
    }
  });
  /* eslint-enable */
};

export default SavedContents;
